import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './VistasPaginaBadge.css';

const getViewerToken = () => {
  let token = localStorage.getItem('viewer_token');
  if (!token) {
    token = 'vt_' + Date.now() + '_' + Math.random().toString(36).substring(2, 12);
    localStorage.setItem('viewer_token', token);
  }
  return token;
};

const formatContador = (num) => {
  const n = Number(num) || 0;
  return n.toLocaleString('es-CL');
};

const formatFecha = () => {
  const d = new Date();
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  return dia + '/' + mes + '/' + d.getFullYear();
};

function VistasPaginaBadge({ pagina }) {
  const [contador, setContador] = useState(null);

  useEffect(() => {
    if (!pagina) return;
    const formData = new FormData();
    formData.append('pagina', pagina);
    formData.append('token', getViewerToken());

    axios.post(process.env.REACT_APP_PUBLICACIONES_URL + '/registrar_vista_pagina.php', formData)
      .then((res) => {
        if (res.data && res.data.success) {
          setContador(res.data.contador);
        }
      })
      .catch((err) => console.error('Error registrando vista de pagina:', err));
  }, [pagina]);

  if (contador === null) return null;

  return (
    <div className="vpp-badge">
      <div className="vpp-badge-inner">
        <span className="vpp-badge-label">Vistas</span>
        <span className="vpp-badge-rule"></span>
        <span className="vpp-badge-numero">{formatContador(contador)}</span>
        <span className="vpp-badge-caption">Actualizado {formatFecha()}</span>
      </div>
    </div>
  );
}

export default VistasPaginaBadge;
